import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogExportDataOptions } from '../../src';
import { ExportSensorDialogComponent } from './export-sensor-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ExportSensorDialogService {
    public static $name: string = 'clExportSensorDialogService';

    constructor(
        public dialog: MatDialog
    ) {
    }

    showDialog(options: DialogExportDataOptions) {
        return this.dialog.open(ExportSensorDialogComponent, { data: options });
    }
}
